
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from "vue-property-decorator";
import BgAvatarUploader from "@/components/bg-avatar-uploader/index.vue";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
import PdfPreviewer from "@/components/pdf-previewer/index.vue";
import { StepForm } from "../../common/StepForm";
import { genCacheMixin } from "../../common/cache.mixin";
@Component({
  components: {
    BgAvatarUploader,
    PdfPreviewer,
  },
  mixins: [
    genCacheMixin({
      field: "form",
      useCache: (ctx: SignProtocols) =>
        !(ctx.data && typeof ctx.data === "object"),
      saveKey: "SignProtocals",
    }),
  ],
})
export default class SignProtocols extends StepForm {
  form = {
    enterpriseInfo: {
      honestyAgreement: "",
    },
  };
  isAgree = false;
  maxSize = 1024 * 1024 * 4;
  PdfPreviewerState = {
    title: "",
    visible: false,
    url: `./attachment/廉洁承诺书.pdf`,
  };
  get rules(): ElementUIFormRules {
    return this.getFieldsRules(["enterpriseInfo.honestyAgreement"]);
  }
  get templateUrl(): string {
    return `./attachment/廉洁承诺函.pdf`;
  }
  created() {
    super.created();
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  async validate() {
    const form = this.getFormRef();
    const valid = await form.validate().catch(() => false);
    if (!this.isAgree) {
      this.$message.warning(
        "请阅读并勾选《供应商系统用户注册协议》和《合作协议》"
      );
      return false;
    }
    return valid;
  }
  getFormData() {
    return this.form;
  }
  handleUploadChange() {
    // 重新校验
    const form = this.getFormRef();
    form.validateField("enterpriseInfo.honestyAgreement");
  }
  previewRegisterProtocalPdf() {
    this.PdfPreviewerState.title = `供应商系统用户注册协议`;
    this.PdfPreviewerState.url = `./attachment/供应商系统用户注册协议.pdf`;
    this.PdfPreviewerState.visible = true;
  }
  previewCooperationProtocalPdf() {
    this.PdfPreviewerState.title = `合作协议`;
    this.PdfPreviewerState.url = `./attachment/合作协议.pdf`;
    this.PdfPreviewerState.visible = true;
  }
}
